import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { ProgramAccountEntity } from "../entities/RewardsProgramAccountEntity";

export interface RewardsProgramAccountState {
    programAccount: ProgramAccountEntity | null;
}

const createInitialState = (): RewardsProgramAccountState => ({
    programAccount: null,
});

@singleton()
@StoreConfig({ name: "RewardsProgramAccountStore" })
class RewardsProgramAccountStore extends BaseStore<RewardsProgramAccountState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsProgramAccountStore;
